// Constants
import { CURRENT_LOCALE_KEY } from '../constants/internationalization.handlers.constants';
// Enumerations
import { StorageLocalEnum } from '@openbank/ziniaweb-ui-core-models';
// Types
import { InternationalizationRegisterTranslationProviderType } from '../../types/internationalization-register-translation.provider.type';

const versionHasChanged = (version: string): boolean =>
  localStorage.getItem(StorageLocalEnum.VERSION) !== version;

const languageHasChanged = (language: string): boolean =>
  localStorage.getItem(CURRENT_LOCALE_KEY) !== language;

const newTranslationsVersionAvailable = ({
  language,
  lastChangedVersion,
}: InternationalizationRegisterTranslationProviderType): boolean =>
  Boolean(
    localStorage.getItem(StorageLocalEnum.TRANSLATIONS) === null ||
      versionHasChanged(lastChangedVersion) ||
      languageHasChanged(language)
  );

export { newTranslationsVersionAvailable };
